import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import {
  getPaginatedTemplatesIfNeeded,
  getTemplateIfNeeded,
  createTemplateFromCurrent,
  updateTemplateFromCurrent,
  getConditionQueries,
  deleteConditionQuery,
  getMinimalConditionQueryTemplatesIfNeeded
} from './sagas';
import {
  GET_PAGINATED_CONDITION_QUERY_TEMPLATES,
  GET_CONDITION_QUERY_TEMPLATE,
  CREATE_CONDITION_QUERY_TEMPLATE,
  UPDATE_CONDITION_QUERY_TEMPLATE,
  CREATING_CONDITION_QUERY_TEMPLATE_FAILED,
  UPDATING_CONDITION_QUERY_TEMPLATE_FAILED,
  GETTING_CONDITION_QUERY_TEMPLATE_FAILED,
  GET_CONDITION_QUERIES,
  DELETE_CONDITION_QUERY,
  DELETING_CONDITION_QUERY_FAILED,
  GETTING_CONDITION_QUERIES_FAILED,
  CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
  UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
  GET_MINIMAL_CONDITION_QUERY_TEMPLATES
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';
import { actions as queryActions } from '../conditionQueryTemplate';

/* Helper Sagas */
function* forceGetAllTemplates(action) {
  yield put(
    queryActions.getConditionQueries({
      data: { schemaIdentifier: action.payload.schemaIdentifier },
      force: true
    })
  );
}
function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest(
    [
      GETTING_CONDITION_QUERIES_FAILED,
      CREATING_CONDITION_QUERY_TEMPLATE_FAILED,
      UPDATING_CONDITION_QUERY_TEMPLATE_FAILED,
      GETTING_CONDITION_QUERY_TEMPLATE_FAILED,
      DELETING_CONDITION_QUERY_FAILED
    ],
    function*(action) {
      yield put(
        userMessaging.setMessageForFailedAction({
          type: action.type,
          error: action.payload
        })
      );
    }
  );
}

/* APP FLOW - Templates */
function* PaginatedConditionQueryTemplateGetManySaga() {
  yield takeLatest(GET_PAGINATED_CONDITION_QUERY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedTemplatesIfNeeded, action);
  });
}
function* ConditionQueryTemplateGetSingleSaga() {
  yield takeLatest(GET_CONDITION_QUERY_TEMPLATE, function*(action) {
    yield call(waitForUserReady);
    yield call(getTemplateIfNeeded, action);
  });
}

// brutally refresh to template list on any modification - this *could* be made to act just on the in-memory reducer instead.
function* ConditionQueryTemplateCreateSaga() {
  yield takeLatest(CREATE_CONDITION_QUERY_TEMPLATE, createTemplateFromCurrent);
}
function* ConditionQueryTemplateUpdateSaga() {
  yield takeLatest(UPDATE_CONDITION_QUERY_TEMPLATE, updateTemplateFromCurrent);
}

function* ConditionQueryTemplateCreateSuccessSaga() {
  yield takeLatest(
    CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
    forceGetAllTemplates
  );
}
function* ConditionQueryTemplateUpdateSuccessSaga() {
  yield takeLatest(
    UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
    forceGetAllTemplates
  );
}

function* GetConditionQueriesSaga() {
  yield takeLatest(GET_CONDITION_QUERIES, getConditionQueries);
}

function* DeleteConditionQuerySaga() {
  yield takeLatest(DELETE_CONDITION_QUERY, deleteConditionQuery);
}

function* MinimalConditionQueryTemplateGetManySaga() {
  yield takeLatest(GET_MINIMAL_CONDITION_QUERY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getMinimalConditionQueryTemplatesIfNeeded, action);
  });
}

export default [
  PaginatedConditionQueryTemplateGetManySaga,
  ConditionQueryTemplateGetSingleSaga,
  ConditionQueryTemplateCreateSaga,
  ConditionQueryTemplateUpdateSaga,
  HandleFailuresSaga,
  GetConditionQueriesSaga,
  DeleteConditionQuerySaga,
  ConditionQueryTemplateCreateSuccessSaga,
  ConditionQueryTemplateUpdateSuccessSaga,
  MinimalConditionQueryTemplateGetManySaga
];
